import React from 'react'
import ReactDOM from 'react-dom'
import AppRouter from './routes/AppRouter'
import './styles/style.css'

class App extends React.Component {
    render() {
        return (
            <div>
                <AppRouter />
            </div>
        )
    }
}

ReactDOM.render(<App />, document.getElementById('root'));